export default __webpack_public_path__ + "static/media/T660PROGREF-1.7.eeb91987.zip";